export enum RulePages {
  List = 'list',
  Edit = 'edit',
  Create = 'create',
}
